<template>
    <md-toolbar v-if="position === 'top'">
        <div class="md-toolbar-row">
            <div class="md-toolbar-section-start">

                <md-button class="md-icon-button" to="/to/">
                    <md-icon>home</md-icon>
                    <md-tooltip md-direction="bottom">Steckbrief</md-tooltip>
                </md-button>

                <md-button class="md-icon-button" to="/to/berufserfahrungen">
                    <md-icon>event_seat</md-icon>
                    <md-tooltip md-direction="bottom">Berufserfahrungen</md-tooltip>
                </md-button>

                <md-button class="md-icon-button" to="/to/ausbildungsdaten">
                    <md-icon>school</md-icon>
                    <md-tooltip md-direction="bottom">Ausbildungsdaten</md-tooltip>
                </md-button>

                <md-button class="md-icon-button" to="/to/projekte" v-if="show_projects">
                    <md-icon>list_alt</md-icon>
                    <md-tooltip md-direction="bottom">Vorstellung ausgewählter IT-Projekte</md-tooltip>
                </md-button>

                <md-button class="md-icon-button" to="/to/kenntnisse">
                    <md-icon>how_to_reg</md-icon>
                    <md-tooltip md-direction="bottom">IT-, Prozess- und sonstige Kenntnisse (Auswahl)</md-tooltip>
                </md-button>

            </div>
            <div class="md-headline">
                <b>Falk Huth.</b>
                <span class="md-xsmall-hide"> Projektmanagement und IT.</span>
            </div>
            <div class="md-toolbar-section-end">

                <md-button class="md-icon-button" to="/to/kontakt">
                    <md-icon>contact_mail</md-icon>
                    <md-tooltip md-direction="bottom">Kontakt</md-tooltip>
                </md-button>

                <md-button class="md-icon-button" to="/" v-if="isLoggedIn()">
                    <md-icon>power_settings_new</md-icon>
                    <md-tooltip md-direction="bottom">Abmelden</md-tooltip>
                </md-button>

            </div>
        </div>
    </md-toolbar>
    <md-toolbar class="md-dense" v-else-if="position === 'bottom'">
        <div class="md-toolbar-row md-dense">
            <div class="md-toolbar-section-start">

                <md-button to="/to/impressum">
                    Impressum
                </md-button>

                <md-button to="/to/datenschutz">
                    Datenschutz
                </md-button>

            </div>
            <div class="md-toolbar-section-end">
                <small class="md-xsmall-hide">
                    Copyright &copy; {{ getCopyrightYears() }}
                </small>
                <small class="md-small-hide" v-if="show_related">
                    &nbsp;by <a href="https://www.ponderosa-software.de" target="_blank">Ponderosa Software UG (haftungsbeschränkt)</a>
                </small>
                <small class="md-small-hide" v-else>
                    &nbsp;by Falk Huth
                </small>
            </div>
        </div>
    </md-toolbar>
    <div v-else>

        <p class="md-title">
            Hauptmenü
        </p>

        <p>
            <router-link to="/to/">
                <md-icon class="left-menu">home</md-icon>
                <md-tooltip md-direction="bottom">Steckbrief</md-tooltip>
            </router-link>
            <router-link to="/to/">
                <span class="left-menu">Steckbrief</span>
            </router-link>
        </p>

        <p class="intended-main-menu-item">
            <router-link to="/to/berufserfahrungen">
                <md-icon class="left-menu">event_seat</md-icon>
                <md-tooltip md-direction="bottom">Berufserfahrungen</md-tooltip>
            </router-link>
            <router-link to="/to/berufserfahrungen">
                <span class="left-menu">Berufserfahrungen</span>
            </router-link>
        </p>

        <p class="intended-main-menu-item">
            <router-link to="/to/ausbildungsdaten">
                <md-icon class="left-menu">school</md-icon>
                <md-tooltip md-direction="bottom">Ausbildungsdaten</md-tooltip>
            </router-link>
            <router-link to="/to/ausbildungsdaten">
                <span class="left-menu">Ausbildungsdaten</span>
            </router-link>
        </p>

        <p class="intended-main-menu-item" v-if="show_projects">
            <router-link to="/to/projekte">
                <md-icon class="left-menu">list_alt</md-icon>
                <md-tooltip md-direction="bottom">Vorstellung ausgewählter IT-Projekte</md-tooltip>
            </router-link>
            <router-link to="/to/projekte">
                <span class="left-menu">IT-Projekte</span>
            </router-link>
        </p>

        <p class="intended-main-menu-item">
            <router-link to="/to/kenntnisse">
                <md-icon class="left-menu">how_to_reg</md-icon>
                <md-tooltip md-direction="bottom">IT-, Prozess- und sonstige Kenntnisse (Auswahl)</md-tooltip>
            </router-link>
            <router-link to="/to/kenntnisse">
                <span class="left-menu">Kenntnisse</span>
            </router-link>
        </p>

        <p>
            <router-link to="/to/kontakt">
                <md-icon class="left-menu">contact_mail</md-icon>
                <md-tooltip md-direction="bottom">Kontakt</md-tooltip>
            </router-link>
            <router-link to="/to/kontakt">
                <span class="left-menu">Kontakt</span>
            </router-link>
        </p>

        <p>
            <router-link to="/to/impressum">
                <md-icon class="left-menu">copyright</md-icon>
                <md-tooltip md-direction="bottom">Impressum</md-tooltip>
            </router-link>
            <router-link to="/to/impressum">
                <span class="left-menu">Impressum</span>
            </router-link>
        </p>

        <p>
            <router-link to="/to/datenschutz">
                <md-icon class="left-menu">policy</md-icon>
                <md-tooltip md-direction="bottom">Datenschutz</md-tooltip>
            </router-link>
            <router-link to="/to/datenschutz">
                <span class="left-menu">Datenschutz</span>
            </router-link>
        </p>

    </div>
</template>

<script>
    // REMARK: route '/to/xxx' will be changes by router.js to '/xxx'
    // this is necessary to change scrollbar even if you go on the same router link
    export default {
        name: "Navigation",
        props: [ "position" ],
        data: () => ({
            // Dieser Teil ist entsprechend anzupassen. Nicht zutreffende Daten sind zu entfernen, fehlende zu ergänzen.
            show_related: false,
            show_projects: false,
        }),
        methods: {
            isLoggedIn() {
                return false;
            },
            getCopyrightYears() {
                var currentYear = new Date().getFullYear();
                return (currentYear > 2019) ? '2019 - ' + currentYear : '2019';
            }
        }
    }
</script>

<style lang="scss" scoped>
    .left-menu {
        padding-left: 20px;
    }
    .intended-main-menu-item {
        padding-left: 32px;
    }
</style>
